import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (<>
    <Helmet>
       <link rel="canonical" href="/"/>
       <title>404: This page could not be found</title>
   </Helmet>

    <Container fluid className="d-flex justify-content-center align-items-center Error_page">
      <Row className="text-center my-0 my-md-3 py-0 py-md-3">
        <Col>
          <div className="my-5 py-md-5 py-3">
            <h1 className="display-1 fw-bold text-black">404</h1>
            <h2 className="fw-medium mb-2 text-black">Oops! Page Not Found</h2>
            <p className="lead mb-4 text-black">
              The page you are looking for does not exist.
            </p>
            <Link to="/">
              <Button size="lg" className='px-5' style={{backgroundColor:"#ffa22b", borderColor:"#ffa22b", color:"#000", fontSize:"18px", fontWeight:"600"}}>Go to Home</Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
    </>);
};

export default NotFound;
